import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms/forms';
import {DirectoryService} from '../../../services/directory.service';
import {ApiClientService} from '../../../services/api-client.service';
import {Resident} from '../../../types/data.types';
import {Observable} from 'rxjs/Observable';
import {AccountPermissionsService} from '../../../services/account-permissions.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'move-out-modal',
    templateUrl: './move-out-modal.component.html',
    styleUrls: ['./move-out-modal.component.scss'],
})

export class MoveOutModalComponent implements OnInit {
    @ViewChild('form') form;
    data = new Resident();
    showModal = false;
    disabledSubmit = false;
    showSpinner = false;
    currentDate: Date = new Date();
    residentsList: Array<any> = [];
    vehiclesList: Array<any> = [];
    petsList: Array<any> = [];
    moveInTo = false;
    moveInToBuildingId = null;
    moveInToSuiteId = null;
    buildingSelectIsDisabled = false;
    buildings: Array<any> = [];
    suites: Array<any> = [];
    moveOutDate = new Date();

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService,
        public account: AccountPermissionsService
    ) {}

    ngOnInit() {
        this.getInfo();
        setTimeout( () => this.showModal = true, 300);
    }

    onSubmit(form: NgForm): void {
        const residentsToDelete = this.residentsList.filter(resident => resident.checked);
        const vehiclesToDelete = this.vehiclesList.filter(vehicle => vehicle.checked);
        const petsToDelete = this.petsList.filter(pet => pet.checked);
        let observableBatch = [];

        if(!residentsToDelete.length && !vehiclesToDelete.length && !petsToDelete.length) {
            toastr.warning('Please, select something first.');
            return;
        }
        if(!this.moveInTo) {
            const data = {moveOutDate: moment(this.moveOutDate).format('YYYY-MM-DD')};
            if (residentsToDelete.length > 0) {
                residentsToDelete.forEach(resident => {
                    observableBatch.push(this.api.patch('domainBD', `/v1/suite-users/${resident.suiteUser[0].id}`, data));
                });
            }
            if (vehiclesToDelete.length > 0) {
                vehiclesToDelete.forEach(vehicle => {
                    observableBatch.push(this.api.patch('domainBD', `/v1/vehicle/${vehicle.id}`, data));
                });
            }
            if (petsToDelete.length > 0) {
                petsToDelete.forEach(pet => {
                    observableBatch.push(this.api.patch('domainBD', `/v1/pet/${pet.id}`, data));
                });
            }
            this.showSpinner = true;
            Observable.forkJoin(observableBatch).subscribe(() => {
                toastr.success('This resident has now been marked as moved out and therefore will no longer have access to their account.');
                this.directoryService.moveOutFormResident.refreshEmitter.emit();
                this.hideModal(form);
            }, error => {
                this.api.errorHandler(error, 'Some of the items have not been deleted.');
                this.showSpinner = false;
            });
        } else {
            if(!this.moveInToBuildingId || !this.moveInToSuiteId) {
                toastr.warning('Both building and suite must be selected for move in to procedure.');
                return;
            }
            if (residentsToDelete.length > 0) {
                const data = {
                    building: this.moveInToBuildingId,
                    suite: this.moveInToSuiteId,
                    // corpNumber: this.directoryService.buildingsForUpdate.find(b => b.id == this.moveInToBuildingId).corporationNumber,
                };
                residentsToDelete.forEach(resident => {
                    observableBatch.push(this.api.patch('domainBD', `/v1/suite-users/${resident.suiteUser[0].id}`, data));
                });
            }
            if (vehiclesToDelete.length > 0) {
                const data = {
                    building: this.moveInToBuildingId,
                    suite: this.moveInToSuiteId,
                    // corpNumber: this.directoryService.buildingsForUpdate.find(b => b.id == this.moveInToBuildingId).corporationNumber,
                };
                vehiclesToDelete.forEach(vehicle => {
                    observableBatch.push(this.api.patch('domainBD', `/v1/vehicle/${vehicle.id}`, data));
                });
            }
            if (petsToDelete.length > 0) {
                const data = {
                    building: this.moveInToBuildingId,
                    suite: this.moveInToSuiteId,
                    // corpNumber: this.directoryService.buildingsForUpdate.find(b => b.id == this.moveInToBuildingId).corporationNumber,
                };
                petsToDelete.forEach(pet => {
                    observableBatch.push(this.api.patch('domainBD', `/v1/pet/${pet.id}`, data));
                });
            }
            this.showSpinner = true;
            Observable.forkJoin(observableBatch).subscribe(() => {
                toastr.success('All selected items have now been moved.');
                this.directoryService.moveOutFormResident.refreshEmitter.emit();
                this.hideModal(form);
            }, error => {
                this.api.errorHandler(error, 'Some of the items have not been moved.');
                this.showSpinner = false;
            });
        }
    }

    hideModal(form) {
        this.directoryService.showMoveOutModal = false;
        this.directoryService.moveOutFormResident = null;
    }

    getInfo() {
        const suite = this.directoryService.moveOutFormResident.suiteId;
        this.api.get('domainBD', `/v1/residents?suite_id=${suite}&expand=suiteUser&per-page=1000`).subscribe(
            res => {
                    this.residentsList = JSON.parse(res._body).entities;
                    if(this.residentsList.find(res => res.id == this.directoryService.moveOutFormResident.id))
                        this.residentsList.find(res => res.id == this.directoryService.moveOutFormResident.id).checked = true;
                },
            error => this.api.errorHandler(error, 'Failed to get residents')
        );
        this.api.get('domainBD', this.directoryService.directoryData.vehicles.get + `&suite_id=${suite}&per-page=1000`).subscribe(
            res => this.vehiclesList = JSON.parse(res._body).entities,
            error => this.api.errorHandler(error, 'Failed to get vehicles')
        );
        this.api.get('domainBD', this.directoryService.directoryData.pets.get + `&suite=${suite}&per-page=1000`).subscribe(
            res => this.petsList = JSON.parse(res._body).entities,
            error => this.api.errorHandler(error, 'Failed to get pets')
        );
        this.getBuildings();
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    changeBuilding(buildingId: string) {
        this.form.controls['moveInToSuiteId'].reset();
        this.getSuites(+buildingId);
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        this.buildingSelectIsDisabled = true;
        const url = `/v1/buildings/short.json?per-page=10000&order-by=name|asc`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.buildings = JSON.parse(res._body).entities;
                this.buildingSelectIsDisabled = false;
                this.buildings = this.account.getBuildingsForUpdate(this.buildings, 'bldn');
                if(this.buildings.length === 1) {
                    this.moveInToBuildingId = this.buildings[0].id;
                    this.getSuites(this.moveInToBuildingId);
                }
            },
            error => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    getSuites(buildingId: number): void {
        if (!buildingId) return;
        this.suites = [];
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
            () => this.buildingSelectIsDisabled = false
        );
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/directory/move-out-modal/move-out-modal.component.ts